export default __webpack_public_path__ + "496508e2279cf54ec3d7e7c9bbca4e55.svg";